import { Dialog } from "@headlessui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { FormBox, ModalFoterBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import FormController from "../../components/fields/FormController";
import { Modal, ModalProp } from "../../components/modal/Modal";
import { VideoCategorys, videoCategorysSchema } from "../../model/VideoCategorys";
import { Spiner } from "../../components/spinner/Spiner";
import DraggableTable, { GridCol, GridRow } from "../../components/table/DraggableTable";

export type MovieCategoriesModalProp = {
  videoCategory?: VideoCategorys;
  authorUid: string;
  isContentsOpen: boolean;
  genreColumns: GridCol[];
  genreRowList: GridRow[];
  genreDraggable: (rowDatas: any) => Promise<void>;
  contentsToggle: () => void;
  onSubmit: (data: VideoCategorys) => Promise<void>;
  isLoad: boolean;
}

export const MovieCategoriesModal = ({
  open,
  toggle,
  closeOnClickOutside,
  updateFlg,
  videoCategory,
  authorUid,
  genreColumns,
  genreRowList,
  genreDraggable,
  contentsToggle,
  isContentsOpen,
  onSubmit,
  isLoad
}: ModalProp & MovieCategoriesModalProp) => {
  const { control, handleSubmit, reset, setValue } =
    useForm<VideoCategorys>({
      resolver: yupResolver(videoCategorysSchema),
      defaultValues: videoCategory,
    });

  useEffect(() => {
    if(updateFlg) {
      setValue('id', videoCategory?.id ?? '');
      setValue('title', videoCategory?.title ?? '');
      setValue('type', videoCategory?.type ?? 'municipality');
      setValue('createUser', authorUid);
      setValue('createAt', videoCategory?.createAt ?? new Date());
    }
  },[videoCategory, setValue, updateFlg, authorUid, isContentsOpen]);

  useEffect(() => {
    if(!open) {
      reset();
    };
  },[open, reset]);

  return (
    <>
      <Modal
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
      >
        <Dialog.Panel className=" relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all sm:w-full max-w-screen-md ">
          <form
            className=""
            onSubmit={handleSubmit(onSubmit)}
          >
          <div className="px-2 pb-4 sm:p-4">
            <div className="text-center sm:mt-3">
              <Dialog.Title
                as="h3"
                className="text-left text-lg font-medium leading-6 text-gray-900"
              >
                ジャンル登録
              </Dialog.Title>
              <div className="overflow-y-auto">
                <div className="px-2 text-left pb-8 h-[500px] ">
                  <FormBox className="flex sm:items-center">
                    <FormController
                      control={control}
                      name={"title"}
                      label={"ジャンル"}
                      type={"text"}
                      required
                    />
                    <Button
                      outline
                      size={'sm'}
                      children={"動画コンテンツ選択"}
                      className={"w-fit"}
                      onClick={contentsToggle}
                    />
                  </FormBox>
                  {isLoad ? (<Spiner/>) : (
                    <DraggableTable
                      gridCol={genreColumns}
                      gridRow={genreRowList}
                      dragEndHandle={genreDraggable}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <ModalFoterBox>
            <Button
              className="mx-2 mt-1 w-[132px]"
              outline
              onClick={toggle}
              children={"キャンセル"}
            />
            <Button
              className="mt-1 mr-2 w-[132px]"
              submit
              children={"登録"}
              disabled={isLoad}
            />
          </ModalFoterBox>
          </form>
        </Dialog.Panel>
      </Modal>
    </>
  )
}